export default "__VITE_ASSET__CLMQTKxB__"